import { LeadBannerPayload } from '@travelata-libs/ui-shared';

export const NAMESPACE = 'lead-banner-store';

export interface StoreLeadState {
    loading: boolean,
    isSubmitted: boolean,
    model: LeadBannerPayload,
}

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        isSubmitted: false,
        model: { phone: '', name: '' }
    }),
    mutations: {
        setModel: (state: StoreLeadState, value: LeadBannerPayload) => {
            state.model = value;
        },
        setLoading: (state: StoreLeadState, value: boolean) => {
            state.loading = value;
        },
        setSubmitted: (state: StoreLeadState, value: boolean) => {
            state.isSubmitted = value;
        }
    },
};